import statesConfig from './states/forgot-password';

export default function (app) {
	statesConfig(app);
};
